<mat-form-field>
  <mat-chip-grid #chipList aria-label="Choose a date" (click)="picker.open()">
    <mat-chip-row *ngFor="let value of model" [removable]="true" (removed)="remove(value)">
      {{ value | date }}
      <mat-icon matChipRemove fontSet="fa" fontIcon="fa-xmark fa-lg"></mat-icon>
    </mat-chip-row>
    <input
      matInput
      hidden
      [value]="resetModel"
      [matDatepicker]="picker"
      [placeholder]="placeholder | translate"
      (dateChange)="dateChanged($event)"
      [matChipInputFor]="chipList"
    />
  </mat-chip-grid>
  <mat-datepicker-toggle matPrefix [for]="picker"></mat-datepicker-toggle>
  <mat-datepicker #picker [startAt]="init" [dateClass]="dateClass"></mat-datepicker>
</mat-form-field>
